module.exports = __webpack_public_path__ + "c6683db3fdb8589bd7851c89639acdaf.jpg";